import styles from "./NetworkSection.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Regional-network cards: circular featured icon + title + description.
 * Surface-aware (default dark, per Figma "Wholesale Supply" band), centered
 * heading. columns 2|3 (default 2); partial last row left-aligned.
 *
 * `subheading` takes a string OR an array of strings. Figma splits this intro
 * into separate paragraphs on several bands (household 5559-21267 desktop /
 * 5598-10659 mobile show two, with a visible gap between them), and collapsing
 * them into one block loses that break. Same convention as `PartnerBand`/
 * `CalloutBand`'s `body`.
 */
export default function NetworkSection({
  heading,
  subheading,
  items = [],
  columns = 2,
  surface = "dark",
}) {
  if (!items.length) return null;

  const intro = Array.isArray(subheading)
    ? subheading.filter(Boolean)
    : subheading
      ? [subheading]
      : [];

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {intro.map((p, i) => (
          <p className={styles.subheading} key={i}>
            {p}
          </p>
        ))}

        <div className={styles.grid} style={{ "--cols": columns }}>
          {items.map((item, i) => (
            <div className={styles.card} key={i}>
              <span className={styles.iconWrap}>
                <img src={resolveIcon(item.icon)} alt="" aria-hidden="true" />
              </span>
              <p className={styles.title}>{item.title}</p>
              {item.desc && <p className={styles.desc}>{item.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
